import _t from 'DOC_ROOT/web/assets/euadmin/src/js/modules/translations';

const waitForCaptcha = (formSelector) => {
    const form = document.querySelector(formSelector);

    form.addEventListener('submit', (e) => {
        const captchaResponse = document.querySelector('input[name="g-recaptcha-response"]');

        if (!captchaResponse || !captchaResponse.value || captchaResponse.value.trim() === '') {
            e.preventDefault();
            // eslint-disable-next-line no-alert
            alert(_t('Captcha verification in progress, please wait...'));
            return false;
        }
        return true;
    });
};

export default waitForCaptcha;
